import { type InputHTMLAttributes, type SelectHTMLAttributes } from "react";
import { CONTROL_BASE, CONTROL_INVALID, CONTROL_SIZE } from "./tokens";

// 폭은 className 이 아니라 fullWidth 로 고른다 — CONTROL_BASE 에 w-full 을 넣으면
// 호출처의 w-64 와 특이도가 같아 Tailwind 생성 순서에 밀려 무시된다.
// sizing 도 같은 이유로 프롭이다 (px-3 vs px-2 충돌 방지).
type ControlProps = {
  sizing?: keyof typeof CONTROL_SIZE;
  fullWidth?: boolean;
};

// HTML 의 size 속성(number)과 이름이 겹치지 않게 sizing 을 쓴다
export function Input({
  sizing = "md",
  fullWidth = true,
  invalid = false,
  className = "",
  ...rest
}: ControlProps & {
  invalid?: boolean;
} & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={`${CONTROL_BASE} ${CONTROL_SIZE[sizing]} ${
        fullWidth ? "w-full" : ""
      } ${invalid ? CONTROL_INVALID : ""} ${className}`}
      {...rest}
    />
  );
}

export function Select({
  sizing = "md",
  fullWidth = true,
  className = "",
  children,
  ...rest
}: ControlProps & SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={`${CONTROL_BASE} ${CONTROL_SIZE[sizing]} ${
        fullWidth ? "w-full" : ""
      } ${className}`}
      {...rest}
    >
      {children}
    </select>
  );
}
